import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\RunScheduledTaskNowController::__invoke
* @see app/Http/Controllers/SAManagement/RunScheduledTaskNowController.php
* @route '/api/sa-management/command-runner/schedule/run'
*/
const RunScheduledTaskNowController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RunScheduledTaskNowController.url(options),
    method: 'post',
})

RunScheduledTaskNowController.definition = {
    methods: ["post"],
    url: '/api/sa-management/command-runner/schedule/run',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SAManagement\RunScheduledTaskNowController::__invoke
* @see app/Http/Controllers/SAManagement/RunScheduledTaskNowController.php
* @route '/api/sa-management/command-runner/schedule/run'
*/
RunScheduledTaskNowController.url = (options?: RouteQueryOptions) => {
    return RunScheduledTaskNowController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\RunScheduledTaskNowController::__invoke
* @see app/Http/Controllers/SAManagement/RunScheduledTaskNowController.php
* @route '/api/sa-management/command-runner/schedule/run'
*/
RunScheduledTaskNowController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RunScheduledTaskNowController.url(options),
    method: 'post',
})

export default RunScheduledTaskNowController